import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const WorkNestPreset = definePreset(Aura, {
  primitive: {
    wn: {
      50: '#ecfdf5',
      100: '#d1fae5',
      200: '#a7f3d0',
      300: '#6ee7b7',
      400: '#34d399',
      500: '#0f766e',
      600: '#0d5f59',
      700: '#0b534a',
      800: '#0a453f',
      900: '#073c37',
      950: '#042f2b',
    },
  },
  semantic: {
    primary: {
      50: '{wn.50}',
      100: '{wn.100}',
      200: '{wn.200}',
      300: '{wn.300}',
      400: '{wn.400}',
      500: '{wn.500}',
      600: '{wn.600}',
      700: '{wn.700}',
      800: '{wn.800}',
      900: '{wn.900}',
      950: '{wn.950}',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617',
        },
        primary: {
          color: '{primary.600}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.700}',
          activeColor: '{primary.800}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.200}, {surface.0} 12%)',
          focusBackground: 'color-mix(in srgb, {primary.300}, {surface.0} 10%)',
          color: '{primary.900}',
          focusColor: '{primary.950}',
        },
        text: {
          color: '#0f172a',
          hoverColor: '#1e293b',
          mutedColor: '#64748b',
          hoverMutedColor: '#475569',
        },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617',
        },
        primary: {
          color: '{primary.300}',
          contrastColor: '{surface.950}',
          hoverColor: '{primary.200}',
          activeColor: '{primary.100}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 62%)',
          focusBackground: 'color-mix(in srgb, {primary.300}, transparent 54%)',
          color: '{surface.0}',
          focusColor: '{surface.0}',
        },
        text: {
          color: '#f8fafc',
          hoverColor: '#ffffff',
          mutedColor: '#94a3b8',
          hoverMutedColor: '#e2e8f0',
        },
      },
    },
  },
});

export default WorkNestPreset;
